import React, { useEffect, useState } from 'react'

import { Button, Container, Dialog, Grid, IconButton, Paper, Typography } from '@mui/material'
import { PropsInterfaceDetalheDataTableCrud, StatusForm } from '../../../DevComponents/DataTableCrud'

import ClsValidacao from '../../../Utils/ClsValidacao'

import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import InputText from '../../../DevComponents/InputText'
import Condicional from '../../../Layout/Condicional'
import ComboBox from '../../../DevComponents/ComboBox'
import { DrgCorrespondenciaDetalheInterface } from '../../../ImportBackend/Interfaces/DrgInterfaces'
import { CrudDetalhePropsInterface } from './DRGClientesDePara'

export default function DRGClientesDeParaInput ( {
  onConfirmarExclusao,
  onConfirmarEdicaoInclusao,
  onCancelar,
  open,
  statusForm,
  registro,
  titulo,
  props = { conteudoPermitido: [], valorUnico: false }
}: PropsInterfaceDetalheDataTableCrud<DrgCorrespondenciaDetalheInterface, CrudDetalhePropsInterface> ) {

  const TituloForm = {
    [StatusForm.Incluindo]: 'Inclusão de "De - Para"',
    [StatusForm.Excluindo]: 'Exclusão de "De - Para"',
    [StatusForm.Exibindo]: '"De - Para"',
    [StatusForm.Editando]: 'Alteração de Dados "De - Para"',
    [StatusForm.Inicial]: 'Dados de "De - Para"',
  }

  const [dados, setDados] = useState<DrgCorrespondenciaDetalheInterface>( { ...registro } )

  useEffect( () => {
    setDados( { ...registro } )
    // console.log( 'dados validados', registro.dadosValidos )
  }, [registro] )

  const [erros, setErros] = useState( {} )

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.naoVazio( 'conteudoBancoDados', dados, erros, retorno )
    retorno = clsValidacao.naoVazio( 'conteudoDrg', dados, erros, retorno )

    setErros( erros )

    return retorno

  }

  const btConfirmar = () => {

    if ( validarDados() ) {
      onConfirmarEdicaoInclusao( dados )
    }

  }

  return (
    <Dialog open={open} onClose={onCancelar}>

      <Container maxWidth="md" sx={{ my: 3 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                {titulo}
                <Typography variant="body2" gutterBottom>
                  {TituloForm[statusForm]}
                </Typography>
              </Typography>

              <IconButton onClick={() => onCancelar()}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <InputText
              dados={dados}
              field='conteudoBancoDados'
              label='De'
              maxLength={255}
              setState={setDados}
              erros={erros}
              disabled={statusForm === StatusForm.Excluindo || props.valorUnico}
            />
          </Grid>

          <Condicional condicao={props.conteudoPermitido.length > 0}>

            <Grid item xs={12}>
              <ComboBox
                campoDescricao='descricaoConteudo'
                campoID='chave'
                dados={dados}
                field='conteudoDrg'
                label='Para:'
                opcoes={props.conteudoPermitido}
                disabled={statusForm === StatusForm.Excluindo}
                setState={setDados}
              />
            </Grid>

          </Condicional>

          <Condicional condicao={props.conteudoPermitido.length === 0}>

            <Grid item xs={12}>
              <InputText
                dados={dados}
                field='conteudoDrg'
                label='Para:'
                disabled={statusForm === StatusForm.Excluindo}
                setState={setDados}
                maxLength={255}
                erros={erros}
              />
            </Grid>

          </Condicional>

          {/* Campos do Formulário de De - Para 
          <Grid item xs={12} >
            <InputText
              dados={dados}
              field='conteudoBancoDados'
              label='Banco de Dados'
              maxLength={255}
              setState={setDados}
              erros={erros}
              disabled={statusForm === StatusForm.Excluindo}
            />
          </Grid>
            */}

          <Grid item xs={12} sx={{ mt: 3 }}>

            <Condicional condicao={![StatusForm.Editando, StatusForm.Incluindo].includes( statusForm )}>
              <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => onConfirmarExclusao()}>Confirmar</Button>
            </Condicional>

            <Condicional condicao={statusForm !== StatusForm.Excluindo}>
              <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => btConfirmar()}>Confirmar</Button>
            </Condicional>

            <Button variant='contained' startIcon={<CloseIcon />} sx={{ py: 1 }} onClick={() => onCancelar()}>Cancelar</Button>

          </Grid>

        </Paper>
      </Container>

    </Dialog>
  )

}